export const Env = {
  API_URL: process.env.REACT_APP_API_URL || 'https://my.houstonproperties.com/api/home-search',
  GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
};
